module.exports = __webpack_public_path__ + "img/coins.0b0b00e3.svg";